import { render, staticRenderFns } from "./HistoryDetail.vue?vue&type=template&id=5d551cce&scoped=true&"
import script from "./HistoryDetail.vue?vue&type=script&lang=ts&"
export * from "./HistoryDetail.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryDetail.vue?vue&type=style&index=0&id=5d551cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d551cce",
  null
  
)

export default component.exports